import { render, staticRenderFns } from "./customerReport.vue?vue&type=template&id=3c7b497b"
import script from "./customerReport.vue?vue&type=script&lang=js"
export * from "./customerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports